import React from "react";
import "primeflex/primeflex.css";
import '../css/Form.css'

const ProSectionHeader = ({headerText})=>{
    return <div className="p-field p-col-12 p-md-12"> 
      <div className="p-d-flex p-jc-start">
      <h6 className="form-header">{headerText}</h6>
    </div>
   
    </div>

}

export default ProSectionHeader;

